export default {
      id: "hospital-usage",
      viewBox: "0 0 22 27.997",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#hospital",
      toString: function () {
        return this.url;
      }
    }